import { IconSearch } from '@tabler/icons'
import { Button, Input, Popover, Select, Space, Switch } from 'antd'
import React, { useEffect, useState } from 'react'
import { View } from 'styles/reactnative'
import { column_walletlist_page } from '../../components/AdminUserModal/UserInfoTabs/column_walletlist_page'
import TableAPI from '../../components/TableAPI'
import { useUserGroup } from '../../hooks/user/usergroups'
import { useUserList } from '../../hooks/user/userlist'
import SettingGroup from '../AdminSystem/SettingGroup'

const Other = ({ title, type }: any) => {
	const [search, setSearch] = React.useState('')
	const [wallettype, setWallettype] = React.useState(9)
	const [exceptType1, setExceptType1] = useState(true)
	const [exceptType2, setExceptType2] = useState(true)
	const [exceptType3, setExceptType3] = useState(true)
	const [exceptType4, setExceptType4] = useState(true)
	const [exceptType5, setExceptType5] = useState(true)
	const [exceptType6, setExceptType6] = useState(true)
	const [exceptType7, setExceptType7] = useState(true)

	const [group, setGroup] = React.useState('*')
	const [userId, setUserId] = React.useState('')
	const { type1 } = useUserGroup()
	const { usertype1 } = useUserList()

	const [temp, setTemp] = React.useState('')

	const [exceptType, setExceptType] = useState('')
	useEffect(() => {
		let exceptType = ''
		if (exceptType1) exceptType += `${exceptType ? ',' : ''}-2`
		if (exceptType2) exceptType += `${exceptType ? ',' : ''}-1`
		if (exceptType3) exceptType += `${exceptType ? ',' : ''}-9`
		if (exceptType4) exceptType += `${exceptType ? ',' : ''}6, -10`
		if (exceptType5) exceptType += `${exceptType ? ',' : ''}7`
		if (exceptType6) exceptType += `${exceptType ? ',' : ''}5`
		if (exceptType7) exceptType += `${exceptType ? ',' : ''}9,99`
		setExceptType(exceptType)
	}, [exceptType1, exceptType2, exceptType3, exceptType4, exceptType5, exceptType6, exceptType7])

	return (
		<View style={{ width: '100%' }}>
			<View
				style={{
					flexDirection: 'row',
					backgroundColor: 'white',
					justifyContent: 'space-between',
					width: '100%',
					padding: 10,
					marginTop: 10,
					borderTopLeftRadius: 10,
					borderTopRightRadius: 10,
				}}>
				<Space direction="horizontal">
					<SettingGroup
						title={'그룹설정'}
						group={group}
						setGroup={setGroup}
						defaultv="*"
						style={{ borderBottom: 0 }}
					/>
					<Popover
						trigger={'click'}
						content={
							<Space style={{ alignItems: 'center' }}>
								<Select
									defaultValue={''}
									style={{ width: '100%', minWidth: 200 }}
									onChange={e => {
										setUserId(e)
										setTemp(e)
									}}
									options={[
										{ value: '', label: '전체' },
										...(usertype1 || []),
									]}
								/>
							</Space>
						}>
						<Input
							placeholder="회원코드"
							style={{ width: '100%', minWidth: 180 }}
							value={temp}
							onKeyDown={e => {
								if (e.key === 'Enter') {
									setUserId(temp)
								}
							}}
							onChange={e => {
								setTemp(e.target.value)
							}}
						/>
					</Popover>
					<Button
						onClick={() => {
							setUserId(temp)
						}}
						style={{ paddingTop: 0 }}
						size="small">
						<IconSearch />
					</Button>
				</Space>

				<Select
					placeholder="지갑계좌"
					filterOption={true}
					options={[
						{ value: '', label: '전체' },
						{ value: 9, label: '원화' },
						{ value: 0, label: '코인현물' },
						{ value: 1, label: '코인선물' },
					]}
					value={wallettype}
					onChange={value => {
						setWallettype(value)
					}}
					style={{ width: 150, marginRight: 10 }}
				/>
				<Space size="small">
					제외
					<Space
						size={'small'}
						style={{
							border: '1px solid #ccc',
							padding: 5,
							borderRadius: 5,
						}}>
						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							거절
							<Switch
								onChange={e => setExceptType1(e)}
								defaultChecked={exceptType1}
							/>
						</Space.Compact>
						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							대기
							<Switch
								onChange={e => setExceptType2(e)}
								defaultChecked={exceptType2}
							/>
						</Space.Compact>
						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							블랙
							<Switch
								onChange={e => setExceptType3(e)}
								defaultChecked={exceptType3}
							/>
						</Space.Compact>
						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							모의
							<Switch
								onChange={e => setExceptType4(e)}
								defaultChecked={exceptType4}
							/>
						</Space.Compact>

						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							페이크
							<Switch
								onChange={e => setExceptType5(e)}
								defaultChecked={exceptType5}
							/>
						</Space.Compact>
						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							파트너
							<Switch
								onChange={e => setExceptType6(e)}
								defaultChecked={exceptType6}
							/>
						</Space.Compact>
						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							관리자
							<Switch
								onChange={e => setExceptType7(e)}
								defaultChecked={exceptType7}
							/>
						</Space.Compact>
					</Space>
				</Space>
			</View>
			<TableAPI
				title={title}
				columns={column_walletlist_page}
				usermodal={true}
				height={'default'}
				apikey={`/admin/walletlist?${
					(userId ? 'userid=' + userId : 't=') +
					(wallettype
						? '&type=wallet_type&searchWord=' + wallettype
						: '') +
					(exceptType && `&excepttype=${exceptType}`) +
					(group ? '&group=' + group : '')
				}`}
			/>
		</View>
	)
}

export default React.memo(Other)
